import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import s from './PhoneForm.module.css';

const PhoneForm = ({ renderPhone, children, className }) => {
  return (
    <div className={cn(s.root, className)}>
      {renderPhone()}
      <div className={s.formContainer}>{children(s.section)}</div>
    </div>
  );
};

PhoneForm.propTypes = {
  renderPhone: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default PhoneForm;
